const app = require('../app');
require('firebase/auth');
let auth = app.auth();
if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development')
  auth.useEmulator('http://localhost:9099');
module.exports = auth;
